import { useState } from 'react';
import ChangelogModal, { type ChangelogEntry } from './ChangelogModal';

const VERSION = '2026.05.28.14.41';

const CHANGELOG: ChangelogEntry[] = [
  {
    version: '2026.05.28.14.41',
    date: '28/05/2026',
    changes: [
      { type: 'fix', description: 'Backend: ngăn OOM crash khi Pancake sync fetch 13,940+ conversation vào memory cùng lúc dashboard gọi nhiều endpoint song song. Tăng container memory 512M → 2G, set NODE_OPTIONS=--max-old-space-size=1536, và serialize sync giữa các khoảng ngày khác nhau bằng global lock.' },
    ],
  },
  {
    version: '2026.05.28.13.37',
    date: '28/05/2026',
    changes: [
      { type: 'fix', description: 'Backend: tự động khôi phục connection pool tới SQL Server khi bị stale. Trước đó pool có thể kẹt ở trạng thái "connected" nhưng tất cả 10 connection đã chết, khiến mọi request OPS Dashboard chờ 30s rồi trả 500 "operation timed out for an unknown reason" — phải restart container mới hết. Nay fail fast 10s, tự reset pool khi error, và healthcheck tự heal.' },
    ],
  },
  {
    version: '2026.04.21.15.14',
    date: '21/04/2026',
    changes: [
      { type: 'feat', description: 'OPS Dashboard: thêm sub-menu "Kiểm soát nội bộ" — thống kê nhân viên nội bộ book lịch tập nhưng không đến (BookingStatus = Out of Time). Gồm 3 bảng: theo phòng ban, theo nhân viên (kèm danh sách booking vi phạm), chi tiết vi phạm với Booking ID link sang CMS admin.25fit.com. Map Member → Admin qua số điện thoại để lấy Title/Studio/Chức vụ.' },
      { type: 'feat', description: 'UI Conventions: dashboard dạng bảng phải hỗ trợ sort (click header), filter search, export CSV. Áp dụng cho bảng mới trong Kiểm soát nội bộ.' },
    ],
  },
  {
    version: '2026.04.20.15.49',
    date: '20/04/2026',
    changes: [
      { type: 'feat', description: 'OPS Heatmap: thêm section "Heatmap Check-in / Session" — hiển thị tỉ lệ check-in/session theo studio × khung giờ (ví dụ 51/6 = 8.5), giúp đánh giá mức độ đông người bình quân mỗi lớp.' },
    ],
  },
  {
    version: '2026.04.20.14.39',
    date: '20/04/2026',
    changes: [
      { type: 'fix', description: 'Weekly Gap: sửa filter "NOT EXISTS Renew PO" trong 4-gap-members.sql — thêm loại VOUCHER PO để đồng bộ RenewCreate. Trước đó member có other membership kèm voucher renew PO bị loại sai khỏi Gap, làm công thức At-risk = Renew + Quit + Gap lệch +1.' },
    ],
  },
  {
    version: '2026.04.20.11.28',
    date: '20/04/2026',
    changes: [
      { type: 'fix', description: 'Weekly report: sửa công thức Paying/At-risk bị lệch khi có member mua gói Upsell hết hạn trong cùng tuần. Step UpsellCreate giờ yêu cầu membership mới còn hạn sau @To (đồng bộ với RenewCreate). Ảnh hưởng 3 file SQL: 3-quit-members, 4-gap-members, 5-upsell-create-membership.' },
    ],
  },
  {
    version: '2026.04.15.17.19',
    date: '15/04/2026',
    changes: [
      { type: 'feat', description: 'eSMS: tra cứu SMS theo SĐT — nhập số để xem toàn bộ tin nhắn đã gửi (nội dung, loại, brandname, giá, trạng thái). Match 9 chữ số cuối, cap 31 ngày.' },
    ],
  },
  {
    version: '2026.04.15.15.44',
    date: '15/04/2026',
    changes: [
      { type: 'feat', description: 'eSMS: thêm toggle "Tổng / Theo loại" trên trend chart (stacked bar theo 6 loại SMS).' },
      { type: 'feat', description: 'eSMS: section Brandname — thống kê số SMS, chi phí, success rate theo từng brandname đăng ký + breakdown theo loại.' },
      { type: 'feat', description: 'eSMS: section Zalo OA — liệt kê OA đã đăng ký kèm quota còn lại (live từ eSMS API).' },
      { type: 'feat', description: 'eSMS: bảng Top Recipients — top 20 SĐT nhận SMS nhiều nhất trong kỳ (cap 31 ngày).' },
      { type: 'feat', description: 'eSMS: panel bảng giá tham khảo SMS CSKH + Quảng cáo (GetSMSPrice/GetSMSPriceAds, cache 24h).' },
      { type: 'feat', description: 'eSMS sync: aggregate thêm theo brandname, lưu bảng report.esms_brandname_daily.' },
    ],
  },
  {
    version: '2026.04.14.11.53',
    date: '14/04/2026',
    changes: [
      { type: 'fix', description: 'Fix Lead/MQL/OPP/Customer = 0 khi chọn range dài (1 tháng): retry 2s/4s/8s/16s khi HubSpot trả 429 secondly rate limit.' },
    ],
  },
  {
    version: '2026.04.14.11.35',
    date: '14/04/2026',
    changes: [
      { type: 'feat', description: 'Messaging: chuyển sang stacked bar chart, hiển thị tổng trên đỉnh cột, breakdown theo từng Page.' },
      { type: 'feat', description: 'Thêm icon platform (Facebook/Instagram/TikTok) + sort 3 cột Page/Platform/Messages trong bảng.' },
      { type: 'feat', description: 'Pancake cache tag counts (Lead/MQL/OPP/Member) vào SQL Server, bỏ hoàn toàn live API cho past days.' },
      { type: 'feat', description: 'Auto-sync Pancake mỗi 02:00 VN — rolling 7 ngày cuối để pick up tag updates muộn.' },
      { type: 'feat', description: 'Migrate storage nội bộ SQLite → SQL Server (schema report).' },
      { type: 'feat', description: 'Tooltip thông tin: auto-linkify URL + pin khi click để mở link HubSpot report.' },
      { type: 'fix', description: 'Lead = 176 khớp HubSpot report: thêm 3 filter lead_unqualified_reason, studio, telesale.' },
      { type: 'fix', description: 'MQL = 128 khớp HubSpot: query riêng theo date_entered_mql + post-filter loại contacts hiện là lead.' },
      { type: 'fix', description: 'Funnel Trend daily sums khớp chính xác với Unified totals (leads/mql/opp/customers).' },
      { type: 'fix', description: 'OPP filter: thêm studio + channel server-side, match HubSpot report chính xác.' },
    ],
  },
  {
    version: '2026.04.13.09.06',
    date: '13/04/2026',
    changes: [
      { type: 'feat', description: 'Nguồn Tin nhắn chuyển sang Pancake (Facebook Insights đã deprecate), đếm conversation INBOX mới theo inserted_at GMT+7.' },
      { type: 'feat', description: 'Cache SQLite internal: dữ liệu ngày quá khứ lưu permanent, hôm nay fetch live từ Pancake — dashboard load < 50ms cho past range.' },
      { type: 'feat', description: 'Bảng "Tin nhắn mới theo Page" hiển thị INBOX per-page kèm Platform, có ghi chú cách tính (GMT+7, chỉ INBOX, không tính comment).' },
      { type: 'feat', description: 'Section "Tin nhắn" đưa lên vị trí #2, ngay sau Phễu marketing thống nhất.' },
      { type: 'feat', description: 'Endpoint POST /api/marketing/messaging/sync?from&to[&reset=1] để backfill/resync thủ công.' },
      { type: 'fix', description: 'Fix timezone boundary: inserted_at không có TZ marker bị parse shift 7h trên server VN-tz (trước đây lệch 1 ngày ở convos tạo gần nửa đêm UTC).' },
      { type: 'fix', description: 'Fallback Pancake v1 user-API cho page không có quyền Admin, retry backoff khi API trả 429.' },
    ],
  },
  {
    version: '2026.04.09.17.10',
    date: '09/04/2026',
    changes: [
      { type: 'feat', description: 'Phễu Marketing Thống Nhất: tích hợp 3 nền tảng Facebook Ads + HubSpot CRM + Pancake Tags.' },
      { type: 'feat', description: 'Sơ đồ hành trình khách hàng trực quan: Thấy quảng cáo → Click → Nhắn tin → Lead → MQL → OPP → Customer.' },
      { type: 'feat', description: 'Scorecards: Tổng chi phí, Clicks, Messages, Lead, MQL, OPP, Customer + Cost per Click/Message/Lead/MQL/OPP/Customer.' },
      { type: 'feat', description: 'Biểu đồ xu hướng phễu: Lead/MQL/OPP/Customer theo ngày (Recharts AreaChart).' },
      { type: 'feat', description: 'Tích hợp HubSpot Contacts API: lifecycle stage dates, trial status, 25fit_channel filter.' },
      { type: 'feat', description: 'Tooltip chi tiết cho mỗi metric: giải thích ý nghĩa, nguồn dữ liệu, API field.' },
      { type: 'fix', description: 'Fix OPP = 0: tách query riêng theo date_booking, sửa trial_1_status true/Yes.' },
      { type: 'fix', description: 'Fix Messages không khớp giữa các chart (7,499 vs 13,748).' },
      { type: 'fix', description: 'Fix off-by-one funnel-trend 32 ngày → 31 ngày.' },
      { type: 'fix', description: 'Fix Lead Rate sai công thức: leads/clicks → leads/messages.' },
      { type: 'fix', description: 'Label rõ nguồn: Leads (Facebook) vs Leads (HubSpot), CPL (Facebook) vs Cost per Lead.' },
      { type: 'fix', description: 'Tooltip canh lề trái thay vì phải.' },
    ],
  },
  {
    version: '2026.04.09.15.20',
    date: '09/04/2026',
    changes: [
      { type: 'feat', description: 'Tích hợp Pancake.vn: dashboard conversations, statistics, customers & posts từ 7 pages (Facebook, Instagram, TikTok).' },
      { type: 'feat', description: 'Tab Pancake trong Report Runner với 5 sub-views: Tổng quan, Hội thoại, Thống kê, Khách hàng, Bài viết.' },
      { type: 'feat', description: 'Tổng quan: scorecards tổng hội thoại, inbox, comment với chi tiết theo từng trang.' },
      { type: 'feat', description: 'Hội thoại: danh sách conversations với lọc inbox/comment, xem chi tiết tin nhắn dạng chat.' },
      { type: 'feat', description: 'Thống kê: campaign ads, staff performance, tag stats, engagement.' },
      { type: 'feat', description: 'Khách hàng: danh sách với SĐT, email, tags, trang, nền tảng.' },
      { type: 'feat', description: 'Bài viết: grid cards với thumbnail, engagement metrics.' },
      { type: 'fix', description: 'Fix pagination conversations API — lấy đầy đủ thay vì bị cắt ở 60.' },
    ],
  },
  {
    version: '2026.04.09.13.38',
    date: '09/04/2026',
    changes: [
      { type: 'feat', description: 'Thêm dashboard Hợp đồng: hiển thị danh sách deals có chứng từ từ HubSpot với file đính kèm.' },
      { type: 'feat', description: 'Xem chi tiết hợp đồng: thông tin deal, danh sách file PDF/ảnh, xem PDF trực tiếp trong modal.' },
      { type: 'feat', description: 'Bộ lọc chứng từ: Biên nhận, Biên lai thu tiền, Hợp đồng, CCCD, Lưu trữ hợp đồng.' },
      { type: 'feat', description: 'Tìm kiếm theo tên khách hàng, studio, SĐT.' },
      { type: 'feat', description: 'Thêm tooltips với định nghĩa field từ Meta API cho tất cả metrics marketing.' },
      { type: 'fix', description: 'Thêm FACEBOOK_ACCESS_TOKEN vào Docker env cho marketing API.' },
      { type: 'fix', description: 'Sửa Docker image registry về đúng blockgene-labs.' },
    ],
  },
  {
    version: '2026.04.08.13.29',
    date: '08/04/2026',
    changes: [
      { type: 'feat', description: 'Thêm Marketing Dashboard: tích hợp Facebook Ads API (chi phí, leads, CPC, CPL, impressions).' },
      { type: 'feat', description: 'Biểu đồ xu hướng chi phí & leads theo ngày/tháng với scorecards và CSV export.' },
      { type: 'feat', description: 'Phễu chuyển đổi: Impressions → Clicks → Tin nhắn → Leads → Thanh toán với tỷ lệ chuyển đổi.' },
      { type: 'feat', description: 'Biểu đồ hiệu quả chi phí: CPL, CPC, CTR theo thời gian.' },
      { type: 'feat', description: 'Phân bổ theo Campaign, Account, Action Type.' },
      { type: 'feat', description: 'Tin nhắn & tương tác từ dữ liệu quảng cáo.' },
      { type: 'feat', description: 'Tooltip giải thích cho CPL, CPC, CTR, Leads.' },
      { type: 'fix', description: 'Sửa bug lead count bị nhân đôi (x2) do trùng onsite_conversion.lead và lead action types.' },
      { type: 'fix', description: 'RevenueBreakdown: ẩn cột doanh thu khi không có ý nghĩa (Action Types).' },
    ],
  },
  {
    version: '2026.04.07.17.58',
    date: '07/04/2026',
    changes: [
      { type: 'feat', description: 'Thêm Revenue Dashboard với dữ liệu từ HubSpot API (thay thế SQL PurchaseOrders).' },
      { type: 'feat', description: 'Dashboard doanh thu theo: Studio, Tỉnh thành, Loại Deal, Loại sản phẩm, Phương thức thanh toán, Nhân viên Sales.' },
      { type: 'feat', description: 'Biểu đồ xu hướng doanh thu theo ngày/tháng với scorecards tổng hợp.' },
      { type: 'feat', description: 'Component RevenueBreakdown tái sử dụng với 3 chế độ: Bảng, Cột, Tỷ trọng.' },
      { type: 'feat', description: 'Thêm quick action chọn nhanh tháng cụ thể (T1-T4) và quý.' },
      { type: 'feat', description: 'Tooltip giải thích công thức tính cho từng metric.' },
      { type: 'fix', description: 'Khớp 100% doanh thu với HubSpot report (filter Deal Won + Deposit, Sales Pipeline, exclude 6 studios đã đóng).' },
      { type: 'fix', description: 'Sửa province mapping: gộp "Hồ Chí Minh" và "Thành phố Hồ Chí Minh", fix Trương Định/Giảng Võ 2/Nguyễn Văn Cừ Long Biên.' },
      { type: 'fix', description: 'In-flight dedup tránh gọi HubSpot API trùng lặp khi nhiều endpoint cùng request.' },
      { type: 'perf', description: 'Cache HubSpot API 5 phút, giảm max-w từ 6xl lên 1600px.' },
    ],
  },
  {
    version: '2026.03.27.17.16',
    date: '27/03/2026',
    changes: [
      { type: 'fix', description: 'Sửa lỗi CONFIG_PATH dùng process.cwd() thay __dirname để resolve đúng /app/config trong Docker.' },
    ],
  },
  {
    version: '2026.03.27.17.08',
    date: '27/03/2026',
    changes: [],
  },
  {
    version: '2026.03.27.16.39',
    date: '27/03/2026',
    changes: [
      { type: 'fix', description: 'Loại trừ block đã bị huỷ (CancelByAdmin) khỏi tính toán CapacitySubtractBlock, tránh Occupancy vượt 100%.' },
      { type: 'fix', description: 'Ngăn trình duyệt cache index.html để deploy mới được áp dụng ngay.' },
    ],
  },
  {
    version: '2026.03.27.15.31',
    date: '27/03/2026',
    changes: [
      { type: 'fix', description: 'Sửa lỗi SlotTaken = -1 (khoá full) không được tính đúng thành MaxParticipants trong công thức CapacitySubtractBlock.' },
      { type: 'fix', description: 'Sửa lỗi cài đặt công thức Capacity bị reset sau khi reload trình duyệt — lưu vào localStorage.' },
      { type: 'fix', description: 'Sửa lỗi PUT /ops/config bị từ chối do backend cũ yêu cầu trường slots không còn tồn tại.' },
      { type: 'feat', description: 'Bảng Occupancy hiển thị thêm 2 cột FullCapacity và Số lượng Block khi dùng CapacitySubtractBlock.' },
      { type: 'feat', description: 'Tooltip (i) giữ nguyên khi click, có nút X để tắt.' },
    ],
  },
  {
    version: '2026.03.27.13.57',
    date: '27/03/2026',
    changes: [
      { type: 'refactor', description: 'Xoá cấu hình slot thủ công, tính capacity trực tiếp từ DB theo từng cặp Studio × Program.' },
      { type: 'feat', description: 'Chuyển filter Tỉnh/Studio/Program lên trên bảng Occupancy, đổi layout tabs xuống dưới.' },
      { type: 'fix', description: 'Rút gọn tên "Thành phố Hà Nội" thành "Hà Nội" trong bảng và filter.' },
      { type: 'fix', description: 'Ẩn dòng có check-in = 0 khỏi bảng Occupancy.' },
      { type: 'fix', description: 'Highlight ngày tháng trong tiêu đề dashboard.' },
    ],
  },
  {
    version: '2026.03.27.10.17',
    date: '27/03/2026',
    changes: [
      { type: 'feat', description: 'OPS Dashboard với light/dark theme, heatmap theo chương trình, Export CSV và sửa lỗi toàn vẹn dữ liệu.' },
      { type: 'feat', description: 'Thêm modal hiển thị changelog và tài liệu quy trình release tự động.' },
      { type: 'fix', description: 'Sửa 6 lỗi không nhất quán dữ liệu trong OPS Dashboard.' },
      { type: 'fix', description: 'Hiển thị đầy đủ nội dung comment với cuộn ngang và cột đầu tiên cố định trong NegativeFeedbackTable.' },
    ],
  },
  {
    version: '2026.03.03.16.06',
    date: '03/03/2026',
    changes: [
      { type: 'feat', description: 'Đồng bộ logic báo cáo kỳ hạn với báo cáo tuần, sử dụng @To cho hiệu lực thành viên, loại trừ thành viên được tặng, và thêm script xác minh cùng tài liệu.' },
    ],
  },
  {
    version: '2026.02.28.19.00',
    date: '28/02/2026',
    changes: [
      { type: 'feat', description: 'Đồng bộ logic báo cáo kỳ hạn với báo cáo tuần, sử dụng @To cho hiệu lực thành viên.' },
      { type: 'feat', description: 'Loại trừ thành viên được tặng (gifted) khỏi báo cáo.' },
      { type: 'feat', description: 'Lưu runId vào localStorage để duy trì khi tải lại trang.' },
    ],
  },
  {
    version: '2026.02.28.18.30',
    date: '28/02/2026',
    changes: [
      { type: 'fix', description: 'Sửa lỗi COPY scripts trong Dockerfile backend.' },
      { type: 'feat', description: 'Thêm CI/CD tự động deploy lên VPS qua GitHub Actions.' },
      { type: 'feat', description: 'Thêm hướng dẫn quy trình phát triển và lưu trữ bền vững cho báo cáo backend.' },
    ],
  },
  {
    version: '2026.02.27',
    date: '27/02/2026',
    changes: [
      { type: 'feat', description: 'Thêm loại báo cáo tháng với giao diện, preset và xử lý backend riêng.' },
      { type: 'feat', description: 'Container hóa ứng dụng bằng Docker và Docker Compose.' },
    ],
  },
  {
    version: '2026.02.26',
    date: '26/02/2026',
    changes: [
      { type: 'feat', description: 'Thêm khoảng thời gian "Tháng sau", cải thiện UX trang visualization.' },
      { type: 'feat', description: 'Cải thiện logic thành viên nghỉ và gap trong báo cáo tuần và kỳ hạn.' },
      { type: 'feat', description: 'Thêm favicon tùy chỉnh thay thế SVG mặc định của Vite.' },
      { type: 'fix', description: 'Sửa hiển thị tóm tắt: hiện trung bình thay vì min/max.' },
    ],
  },
  {
    version: '2026.02.25',
    date: '25/02/2026',
    changes: [
      { type: 'feat', description: 'Thêm báo cáo kỳ hạn thành viên mới, cập nhật visualization và CSV service.' },
      { type: 'feat', description: 'Thêm biểu đồ thành viên trả phí và phân tích theo studio.' },
      { type: 'feat', description: 'Nâng cấp trang visualization với dữ liệu chi tiết theo studio và giao diện mới.' },
    ],
  },
  {
    version: '2026.02.24',
    date: '24/02/2026',
    changes: [
      { type: 'feat', description: 'Lọc thành viên có nguy cơ: chỉ bao gồm thành viên từ 30 ngày trở lên.' },
      { type: 'feat', description: 'Hiển thị tiêu đề báo cáo động theo loại (Kỳ hạn / Tuần).' },
      { type: 'feat', description: 'Render DatePicker dạng portal với hỗ trợ dark theme.' },
      { type: 'refactor', description: 'Tái cấu trúc DataTable với sắp xếp và phân trang tùy chỉnh.' },
      { type: 'fix', description: 'Sửa lỗi TypeScript trong report-runner service.' },
    ],
  },
];

export default function Version() {
  const [showChangelog, setShowChangelog] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowChangelog(true)}
        className="fixed bottom-4 right-4 text-xs text-slate-500 hover:text-cyan-400 font-mono select-none z-50 transition-colors cursor-pointer"
        title="Xem lịch sử cập nhật"
      >
        {VERSION}
      </button>

      <ChangelogModal
        isOpen={showChangelog}
        onClose={() => setShowChangelog(false)}
        changelog={CHANGELOG}
        currentVersion={VERSION}
      />
    </>
  );
}
